import request from '@/utils/request'

export function getCloudStatus(params) {
  return request.post('/amz/pluginOnlineStatus/page', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

export function getCloudReport(params) {
  return request.post('/amz/reportCreateTask/page', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

/**
 * getFollowList  获取跟卖列表
 * @param params
 */
export function getFollowList(params) {
  return request.post('/operation/offerMonitor', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}
/**
 * getFollowDetail  获取跟卖详情
 * @param params
 */
export function getFollowDetail(params) {
  return request.post('/operation/offerMonitor/itemPage', params)
      .then((res) => {
        return Promise.resolve(res.data);
      })
}
/**
 * addFollow
 * @param params
 */
export function addFollow(params) {
  return request.post('/operation/offerMonitor/add', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

/**
 * 更新跟卖监控状态
 * @param params
 * @returns {Promise<unknown>}
 */
export function updateFollowStatus(params) {
  return request.put('/operation/offerMonitor/updateStatus', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}
/**
 * 删除跟卖监控
 * delFollow
 * @param params
 */
export function delFollow(params) {
  return request.delete('/operation/offerMonitor/delete', {data: params})
    .then((res) => {
      return Promise.resolve(res.data);
    })
}
/**
 * 更新跟卖监控
 * editFollowItem
 * @param params
 */
export function editFollowItem(params) {
  return request.put('/operation/offerMonitor/update', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}
/**
 * 获取跟卖监控剩余数量
 * getPackageQuota
 * @param params
 */
export function getPackageQuota(params) {
  return request.get('/base/personalCenter/getPackageQuota', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}
/**
 * 获取跟卖监控已添加的商品
 * getExistingGoods
 * @param params
 */
export function getExistingGoods(params) {
  return request.get('/operation/offerMonitor/existAsin', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

/**
 * 百度埋点
 * uploadConvertData
 * @param params
 */
 export function uploadConvertData(params) {
  return request.post('/oauth/informationRetrieval/anno/bdUpload', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

/**
 * 货件索赔列表查询
 * getShipmentClaimList
 * @param params
 */
export function getShipmentClaimList(params) {
  return request.post('/operation/shipmentClaim/page', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

/**
 * 货件索赔统计
 * getShipmentClaimTotal
 * @param params
 */
export function getShipmentClaimTotal(params) {
  return request.post('/operation/shipmentClaim/statistics', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

/**
 * 货件索赔手动刷新
 * refreshShipmentClaim
 * @param params
 */
export function refreshShipmentClaim(params) {
  return request.post('/operation/shipmentClaim/refresh', params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

/**
 * 货件索赔模板
 * getShipmentClaimTemplate
 * @param params
 */
export function getShipmentClaimTemplate(id) {
  return request.get(`/operation/shipmentClaim/template/${id}`)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}

/**
 * 修改货件索赔
 * updateShipmentClaim
 * @param params
 */
 export function updateShipmentClaim(params) {
  return request.post(`/operation/shipmentClaim/update`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}
